/**
 * Chat composer tools. Each tool lists the OpenRouter/GPTModel
 * `supported_parameters` it needs; the UI and send path only enable a tool
 * when the selected model has all of them.
 */
export type ChatToolDefinition = {
  id: string;
  label: string;
  requiredParameters: readonly string[];
};

export const CHAT_TOOLS: readonly ChatToolDefinition[] = [
  {
    id: "exa_web_search",
    label: "Exa web search",
    requiredParameters: ["tools"],
  },
  {
    id: "create_glossary_entries",
    label: "Create glossary entries",
    requiredParameters: ["tools"],
  },
] as const;

export type ChatToolId = typeof CHAT_TOOLS[number]["id"];

export const isChatToolSupported = (
  tool: ChatToolDefinition,
  supportedParameters: readonly string[] | null | undefined
): boolean => {
  const params = supportedParameters ?? [];
  return tool.requiredParameters.every((parameter) =>
    params.includes(parameter)
  );
};

export const supportedChatToolIds = (
  supportedParameters: readonly string[] | null | undefined
): string[] =>
  CHAT_TOOLS.filter((tool) =>
    isChatToolSupported(tool, supportedParameters)
  ).map((tool) => tool.id);
